module.exports = __webpack_public_path__ + "e3b45cdc2d57a088444d5644ee61586d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1080.webp.png
// module id = 340
// module chunks = 0